/* globals window */

import React, { useState } from 'react';
import { useNotify } from 'react-admin';
import Button from '@material-ui/core/Button';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import { apiPut } from '../brainApi';
import {
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
} from './SettingsUtils';
import NotificationPreferences from '../components/NotificationPreferences';

const useStyles = makeStyles((theme) => ({
  maxWidth: {
    flexBasis: '100%',
    margin: '10px',
  },
  settingsThemeContainer: {
    width: '50%',
    margin: '20px auto 0 auto',
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% - 25px) !important',
      margin: '10px auto 0px auto !important',
    },
  },
}));
const NotificationSettings = () => {
  const browserNotificationsSupported =
    typeof window.Notification !== 'undefined';
  const [expanded, setExpanded] = useState(false);
  const notify = useNotify();
  const [permission, setPermission] = useState(
    browserNotificationsSupported ? Notification.permission : 'default',
  );
  const [
    notificationTypesAndPreferences,
    setNotificationTypesAndPreferences,
  ] = useState({});
  const classes = useStyles();
  const getBrowserNotificationsPermission = () => {
    // https://developer.mozilla.org/en-US/docs/Web/API/notification∂
    if (!browserNotificationsSupported) {
      notify('This browser does not support desktop notifications', 'error');
    }
    // Ask the user for permission
    else if (Notification.permission !== 'denied') {
      Notification.requestPermission().then((response) => {
        // Notification.permission only updates on page refresh, so let's use the promise to set update state variable
        if (response === 'granted') notify('Browser Notifications enabled!');
        setPermission(response);
      });
    } else if (Notification.permission === 'denied') {
      notify(
        "You have previously denied permissions for notifications. Please see your browser's documentation for information on how to reallow notifications",
        'warning',
      );
    }
  };
  const setNotificationPreferences = () => {
    const formattedPreferenceList = [];
    Object.keys(notificationTypesAndPreferences).forEach((category) => {
      notificationTypesAndPreferences[category].forEach((eventType) => {
        formattedPreferenceList.push(eventType);
      });
    });
    apiPut('/employee-notification-preferences', {
      notification_types_and_preferences: formattedPreferenceList,
    }).then(() => {
      notify('Notification Preferences updated!');
    });
  };
  return (
    <div className={classes.settingsThemeContainer}>
      <ExpansionPanel
        square
        expanded={expanded}
        onChange={() => setExpanded(!expanded)}
      >
        <ExpansionPanelSummary
          aria-controls="panel1d-content"
          expandIcon={<ExpandMoreIcon />}
          id="panel1d-header"
        >
          <Typography>Notifications</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails style={{ flexWrap: 'wrap' }}>
          <Button
            variant="contained"
            disabled={permission === 'granted'}
            onClick={() => getBrowserNotificationsPermission()}
          >
            {permission === 'granted'
              ? 'Browser notifications enabled'
              : 'Enable browser notifications'}
          </Button>
          <Divider className={classes.maxWidth} />
          <div className={classes.maxWidth}>
            <NotificationPreferences
              notificationTypesAndPreferences={notificationTypesAndPreferences}
              setNotificationTypesAndPreferences={
                setNotificationTypesAndPreferences
              }
            />
          </div>
          <Button
            variant="contained"
            onClick={() => setNotificationPreferences()}
          >
            Save Notification Preferences
          </Button>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </div>
  );
};
export default NotificationSettings;
